import React, { useState } from "react";
import "./NewsCC.css";
import { toast } from "react-toastify";

const News = () => {
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    name: "",
    mobile: "",
  });

  const [entries, setEntries] = useState(10); // entries select
  const [data, setData] = useState([
    // sample data
    { sn: 1, name: "Navin Kumar", mobile: "9876543210", aadhar: "1234 5678 9012", pan: "ABCDE1234F", voter: "XYZ123", dl: "DL12345", passport: "P12345", ration: "R12345", other: "-", retailScore: 80, mfiScore: 75 },
    { sn: 2, name: "Ramesh Kumar", mobile: "9876543211", aadhar: "2234 5678 9012", pan: "ABCDE1235F", voter: "XYZ124", dl: "DL12346", passport: "P12346", ration: "R12346", other: "-", retailScore: 85, mfiScore: 70 },
    // add more rows here
  ]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    toast.success("Form submitted!");
  };

  const handleEntriesChange = (e) => setEntries(e.target.value);

  return (
    <div className="Newsform-wrapper">
      {/* Form */}
      <form className="Newscustom-form" onSubmit={handleSubmit}>
        <div className="Newsform-row">
          <div className="Newsform-group">
            <label>From Date</label>
            <input
              type="date"
              name="fromDate"
              value={formData.fromDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="Newsform-group">
            <label>To Date</label>
            <input
              type="date"
              name="toDate"
              value={formData.toDate}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="Newsform-row">
          <div className="Newsform-group">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Name"
              required
            />
          </div>
          <div className="Newsform-group">
            <label>Mobile</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter Mobile"
              required
            />
          </div>
        </div>

        <div className="Newssubmit-row">
          <button type="submit">Search</button>
        </div>
      </form>

      {/* Table Controls */}
      <div className="Newsdatatables-controls">
      <div className="Newsdatatable-controls">
  <div className="Newscontrols-inline">
    <button>Excel</button>
    <button>Print</button>
    <select value={entries} onChange={handleEntriesChange}>
      <option value={10}>10</option>
      <option value={25}>25</option>
      <option value={50}>50</option>
    </select>
  </div>
</div>


      {/* Table */}
      <div className="Newsdatatable-container">
  <table className="Newscustom-table">
    <thead>
      <tr>
        <th>Sn</th>
        <th>Name</th>
        <th>Mobile</th>
        <th>Aadhar</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      {data.slice(0, entries).map((row) => (
        <tr key={row.sn}>
          <td>{row.sn}</td>
          <td>{row.name}</td>
          <td>{row.mobile}</td>
          <td>{row.aadhar}</td>
          <td>
            <button
              className="Newsview-btn"
              onClick={() => alert(`Viewing details of ${row.name}`)}
            >
              View
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

      {/* Pagination */}
      <div className="Newsdatatable-pagination">
        <button>Previous</button>
        <button>Next</button>
      </div>
    </div></div>
  );
};

export default News;
